import { Register } from '../../data/Service/UserService';
import axios from 'axios';
import { API_URL } from '../../config/api';

var result = ''

export const cadastro = newUser => {
    return Register(0, '', newUser.email, newUser.senha, '', '', '', '', '', '', '', '', '', '', new Date, newUser.termos_de_uso, newUser.termos_de_compra, newUser.policita_de_privacidade, newUser.status, newUser.data_atualizacao_cadastro, '', '', newUser.cupom);
}

export const getUsers = user => {
    return axios
        .post(`${API_URL}/users/findUser`, {
            email: user
        }).then(res => {
            return res.data
        })
        .catch(err => {            
            return err.response.message
        })
}

export async function requestPaymentAluno(payment){
    return axios.post(`${API_URL}/payment-paypal/buy`, payment);
}

export const requestPayment = payment => {
    return axios.post(`${API_URL}/payment-paypal/buy`, payment);
}

export const buy = cupom => {
    return axios.post(`${API_URL}/payment-paypal/buy`,{
            cupom: cupom
        }).then(res => {
            if (res.status === 201) {
                Object.entries(res.data).map(([key, value]) => {
                    if(value.rel === 'approval_url'){
                        result = value.href
                    }
                })
                window.location = result
            } else {
                window.location.location()
            }
        })
        .catch(err => {
            return err.response.message
        })
}

export const validaCupom = cupom => {
    return axios.post(`${API_URL}/users/validate-cupom`,{
            cupom            
        }).then(res => {
            return res.data
        })
        .catch(err => {
            return err.response.message
        })
}